export default __webpack_public_path__ + "static/media/WarningInvoice.48b4ab21.svg";